// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import index from './store'
import './plugins/base'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import './resources/js/app'
import * as Sentry from '@sentry/vue'
import VueGtag from 'vue-gtag'


Vue.config.productionTip = false


Sentry.init({
  Vue,
  environment: process.env.VUE_APP_SENTRY_ENV,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  tracesSampleRate: process.env.VUE_APP_SENTRY_TRACE_SAMPLE_RATE,
  replaysSessionSampleRate: process.env.VUE_APP_SENTRY_REPLAY_SAMPLE_RATE,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: process.env.VUE_APP_SENTRY_LOGS_ENABLED,
  tracePropagationTargets: [
    'https://*.tilyet.org'
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ]
})

Vue.use(VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GTAG_ID
      }
    }
)

new Vue({
  router,
  store: index,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
